<template>
</template>
<script>
import { Auth, AuthuserInfo, AuthuserInfo_get } from "../../assets/js/url";
export default {
  data() {
    return {
      terminalId: "",
      Key: "",
      ticket: "",
      url:'',
    };
  },
  activated() {
    this.terminalId = this.$route.query.terminalId;
    this.dmaDomain = this.$route.query.dmaDomain;
    this.Key = this.$route.query.key;
    this.ticket = this.$route.query.ticket;
    if (this.terminalId) {
      this.$store.commit("setTrminalId", this.terminalId);
    }
    if (this.dmaDomain) {
      this.$store.commit("setdmaDomain", this.dmaDomain);
    }
    if (window.sessionStorage.getItem("UUID")) {
      this.$router.push({ path: "/vvMeetingList" });
    } else {
      if (this.Key) {
        this.AuthgetUserinfo_get();
      } else {
       window.location.href =Auth + "?terminalId=" + this.terminalId + "&ticket=" + this.ticket;
      }
    }
  },
  methods: {
    AuthgetUserinfo_get() {
      this.$http
        .get(AuthuserInfo_get, {
          params: {
            terminalId: this.terminalId,
            key: this.Key,
            ticket: this.ticket
          }
        })
        .then(res => {
          if (res.data.status == 2000) {
            var userInfo = res.data.data;
            window.sessionStorage.setItem("UUID", userInfo.useruuid);
            window.sessionStorage.setItem('JSESSIONID', userInfo.sid);
			window.localStorage.setItem('pageTitle', userInfo.entSettingInfo.pageTitle);
			window.localStorage.setItem('bannerMobile', userInfo.entSettingInfo.bannerMobile);
            this.$router.push({ path: "/vvMeetingList" });
          } else {
            this.$toast(res.data.data);
          }
        });
    },

  }
};
</script>


// WEBPACK FOOTER //
// src/components/content/vvScan.vue